import { selectUser } from './selectUser';
import { IState } from '../../../store';

export const selectRealtyUserId = (state: IState): number | null => {
  return selectUser(state)?.realtyUserId || null;
};
